import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const KIOSKCARTFOOTERBLOCK_LEGACY_FIELD_ORDER = [
  "primary_button_background_color",
  "primary_button_text_color",
  { type: 'separator' },
  "secondary_button_background_color",
  "secondary_button_text_color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskCartFooterBlockDescriptor: _generatedKioskCartFooterBlockDescriptor,
  kioskCartFooterBlockBlocDefinition,
  kioskCartFooterBlockDashboardLayout,
  kioskCartFooterBlockConfig,
  kioskCartFooterBlockResolveConfig,
  kioskCartFooterBlockProperties,
} = doodBlockConfig(
  {
    name: "Kiosk Cart - Footer",
    componentType: 'KioskCartFooterBlockComponent',
    category: 'kiosk',
    description: "Kiosk Cart - Footer.",
    keywords: [],
    allowedIn: [
      { bloc: 'KioskCartPageComponent', slot: 'footer' },
    ],


    sharedFields: {}
  },

  () => ({
    primary_button_background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-600"},
      options: {
        label: "pages.blocks.kiosk-cart-footer.primary-button-background-color.label",
        help: "pages.blocks.kiosk-cart-footer.primary-button-background-color.help",
      }
    }),
    primary_button_text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-50"},
      options: {
        label: "pages.blocks.kiosk-cart-footer.primary-button-text-color.label",
      }
    }),
    secondary_button_background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-50"},
      options: {
        label: "pages.blocks.kiosk-cart-footer.secondary-button-background-color.label",
      }
    }),
    secondary_button_text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-600"},
      options: {
        label: "pages.blocks.kiosk-cart-footer.secondary-button-text-color.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.kiosk-cart-footer.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.kiosk-cart-footer.fieldset.pay-button.label",
            fields: [
              "primary_button_background_color",
              "primary_button_text_color",
            ],
          },
          {
            legend: "pages.blocks.kiosk-cart-footer.fieldset.back-button.label",
            fields: [
              "secondary_button_background_color",
              "secondary_button_text_color",
            ],
          },
        ],
      },
    ],
  })
);

export function kioskCartFooterBlockDescriptor(): IBlockDescriptor;
export function kioskCartFooterBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskCartFooterBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskCartFooterBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedKioskCartFooterBlockDescriptor, kioskCartFooterBlockProperties, fieldOrder);
}

export {
  kioskCartFooterBlockBlocDefinition,
  kioskCartFooterBlockDashboardLayout,
  kioskCartFooterBlockProperties,
  kioskCartFooterBlockConfig,
  kioskCartFooterBlockResolveConfig,
};

export type KioskCartFooterBlockConfig = typeof kioskCartFooterBlockConfig;
